/* eslint-disable */
import React, { useEffect, useState } from "react";
import "../../styles/candidate_nav.css";
import { useSelector, shallowEqual } from "react-redux";
import _ from "lodash/fp";
import ModuleHide from "../../common/components/ModuleHide";
import commonLabels from "../../common/labels/common_en.json";
import commonHILabels from "../../common/labels/common_hi.json";
import "../../styles/home.css";
import numberformat from "../../common/labels/serial_nos_en.json";

export default function CandidateHome() {
    const { moduleList } = useSelector(state => state.loginReducer, shallowEqual);
    const [arraymModule, setarraymModule] = useState({})

    window.onbeforeunload = function () {
        window.scrollTo(0, 0);
    };

    useEffect(() => {
        setarraymModule(moduleList && moduleList.filter((ele) => ele.moduleName === "HOME_TAB")[0])
    }, [moduleList])

    return arraymModule && arraymModule.isEnabled == false ? < ModuleHide details={arraymModule} /> :
        (
            <div className="container instructions-tab">
                <div className="row card d-flex mb-4 mt-5 common-border">
                    <div className="col-12 border">
                        <p className="text-center text-dark ms-4 mb-0 mt-2 f18">
                            <img src="/icons/integration-instructions.png" className="icons w2 img-fluid"></img>{" "}&nbsp;
                            <span className="font-weight-bold">
                                {commonLabels.HOME_INSTRUCTIONS.INSTRUCTIONS}&nbsp;
                            </span>
                            <span>
                                {commonHILabels.HOME_INSTRUCTIONS.INSTRUCTIONS}
                            </span>
                        </p>
                        <p className="text-center text-danger font-weight-bold ms-4 mb-1 f16">{commonLabels.HOME_INSTRUCTIONS.HOME_NOTE_1}</p>
                        <p className="text-center f16">{commonHILabels.HOME_INSTRUCTIONS.HOME_NOTE_1}</p>
                        <div className="home-instructions-tab">
                            <p className="text-center text-dark ms-4 f18 mb-0">
                                <span className="font-weight-bold">
                                    {commonLabels.HOME_INSTRUCTIONS.HOME_NOTE_2}&nbsp;
                                </span>
                                <br/>
                                <span>
                                    {commonHILabels.HOME_INSTRUCTIONS.HOME_NOTE_2}
                                </span>
                            </p>
                            <p className="border-bottom-dotted-line"></p>
                            <p className="text-start ms-4 mt-4">
                                <span className="home-instructions-steps">
                                    {commonLabels.HOME_INSTRUCTIONS.HOME_NOTE_3}
                                </span>
                                <span>
                                    {commonHILabels.HOME_INSTRUCTIONS.HOME_NOTE_3}
                                </span>
                            </p>
                            <p className="text-start ml38 mb-2">
                                <span className="text-dark">
                                    {commonLabels.HOME_INSTRUCTIONS.HOME_NOTE_3_1}
                                 </span>
                                 <br/>
                                 <span>
                                    {commonHILabels.HOME_INSTRUCTIONS.HOME_NOTE_3_1}
                                 </span>
                            </p>
                            <p className="text-start ml38 mb-2">
                                <span className="text-dark">
                                    {commonLabels.HOME_INSTRUCTIONS.HOME_NOTE_3_2}
                                 </span>
                                 <br/>
                                 <span>
                                    {commonHILabels.HOME_INSTRUCTIONS.HOME_NOTE_3_2}
                                 </span>
                            </p>
                            <p className="text-start ml38 mb-2">
                                <span className="text-dark">
                                    {commonLabels.HOME_INSTRUCTIONS.HOME_NOTE_3_3}
                                 </span>
                                 <br/>
                                 <span>
                                    {commonHILabels.HOME_INSTRUCTIONS.HOME_NOTE_3_3}
                                 </span>
                            </p>
                            <p className="text-start ml38 mb-2">
                                <span className="text-dark">
                                    {commonLabels.HOME_INSTRUCTIONS.HOME_NOTE_3_4}
                                 </span>
                                 <br/>
                                 <span>
                                    {commonHILabels.HOME_INSTRUCTIONS.HOME_NOTE_3_4}
                                 </span>
                            </p>
                            <p className="text-start ml38">
                                <span className="text-dark">
                                    {commonLabels.HOME_INSTRUCTIONS.HOME_NOTE_3_5}
                                 </span>
                                 <br/>
                                 <span>
                                    {commonHILabels.HOME_INSTRUCTIONS.HOME_NOTE_3_5}
                                 </span>
                            </p>
                            <p className="text-start ms-4 mb-2">
                                <span className="home-instructions-steps">
                                    {commonLabels.HOME_INSTRUCTIONS.HOME_NOTE_4}
                                </span>
                                <span>
                                    {commonHILabels.HOME_INSTRUCTIONS.HOME_NOTE_4}
                                </span>
                            </p>
                            <p className="text-start ml38 d-flex align-items-start">
                                <span className="f20 text-dark me-2 flex-shrink-0">•</span>
                                <span className="mt-1">
                                    <span className="text-dark">
                                        {commonLabels.HOME_INSTRUCTIONS.HOME_NOTE_4_1}
                                    </span>
                                    <br/>
                                    <span>
                                        {commonHILabels.HOME_INSTRUCTIONS.HOME_NOTE_4_1}
                                    </span>
                                </span>
                            </p>

                            <p className="text-start ms-4 mb-2">
                                <span className="text-dark font-weight-bold">
                                    {commonLabels.HOME_INSTRUCTIONS.HOME_NOTE_5}
                                </span>
                                <br/>
                                <span>
                                    {commonHILabels.HOME_INSTRUCTIONS.HOME_NOTE_5}
                                </span>
                            </p>
                            <p className="text-start ml38 mb-1">
                                <span className="f20 text-dark me-2">•</span> 
                                <span className="text-dark">
                                    {commonLabels.HOME_INSTRUCTIONS.HOME_NOTE_5_1} 
                                </span>
                                <br/>
                                <span>
                                    {commonHILabels.HOME_INSTRUCTIONS.HOME_NOTE_5_1}
                                </span>
                            </p>
                            <p className="text-start ml38 mb-2">
                                <span className="f20 text-dark me-2">•</span> 
                                <span className="text-dark">
                                    {commonLabels.HOME_INSTRUCTIONS.HOME_NOTE_5_2} 
                                </span>
                                <br/>
                                <span>
                                    {commonHILabels.HOME_INSTRUCTIONS.HOME_NOTE_5_2}
                                </span>
                            </p>
                            <p className="text-start ml70 mb-2">
                                <span className="text-dark">
                                    {numberformat["1"]}.&nbsp; 
                                    {commonLabels.HOME_INSTRUCTIONS.HOME_NOTE_5_2_1}
                                </span>
                                <br/>
                                <span>
                                    {commonHILabels.HOME_INSTRUCTIONS.HOME_NOTE_5_2_1}
                                </span>
                            </p>
                            <p className="text-start ml70 mb-2">
                                <span className="text-dark">
                                    {numberformat["2"]}.&nbsp; 
                                    {commonLabels.HOME_INSTRUCTIONS.HOME_NOTE_5_2_2}
                                </span>
                                <br/>
                                <span>
                                    {commonHILabels.HOME_INSTRUCTIONS.HOME_NOTE_5_2_2}
                                </span>
                            </p>
                            <p className="text-start ml70 mb-2">
                                <span className="text-dark">
                                    {numberformat["3"]}.&nbsp; 
                                    {commonLabels.HOME_INSTRUCTIONS.HOME_NOTE_5_2_3}
                                </span>
                                <br/>
                                <span>
                                    {commonHILabels.HOME_INSTRUCTIONS.HOME_NOTE_5_2_3}
                                </span>
                            </p>
                            <p className="text-start ml70 mb-2">
                                <span className="text-dark">
                                    {numberformat["4"]}.&nbsp; 
                                    {commonLabels.HOME_INSTRUCTIONS.HOME_NOTE_5_2_4}
                                </span>
                                <br/>
                                <span>
                                    {commonHILabels.HOME_INSTRUCTIONS.HOME_NOTE_5_2_4}
                                </span>
                            </p>
                            <p className="text-start ml70 mb-2">
                                <span className="text-dark">
                                    {numberformat["5"]}.&nbsp; 
                                    {commonLabels.HOME_INSTRUCTIONS.HOME_NOTE_5_2_5}
                                </span>
                                <br/>
                                <span>
                                    {commonHILabels.HOME_INSTRUCTIONS.HOME_NOTE_5_2_5}
                                </span>
                            </p>
                            <p className="text-start ml70 mb-2">
                                <span className="text-dark">
                                    {numberformat["6"]}.&nbsp; 
                                    {commonLabels.HOME_INSTRUCTIONS.HOME_NOTE_5_2_6}
                                </span>
                                <br/>
                                <span>
                                    {commonHILabels.HOME_INSTRUCTIONS.HOME_NOTE_5_2_6}
                                </span>
                            </p>
                            <p className="text-start ml70 mb-2">
                                <span className="text-dark">
                                    {numberformat["7"]}.&nbsp; 
                                    {commonLabels.HOME_INSTRUCTIONS.HOME_NOTE_5_2_7}
                                </span>
                                <br/>
                                <span>
                                    {commonHILabels.HOME_INSTRUCTIONS.HOME_NOTE_5_2_7}
                                </span>
                            </p>
                            <p className="text-start ml70">
                                <span className="text-dark">
                                    {numberformat["8"]}.&nbsp; 
                                    {commonLabels.HOME_INSTRUCTIONS.HOME_NOTE_5_2_8}
                                </span>
                                <br/>
                                <span>
                                    {commonHILabels.HOME_INSTRUCTIONS.HOME_NOTE_5_2_8}
                                </span>
                            </p>
                            <p className="text-start ml38 d-flex align-items-start mb-2">
                                <span className="f20 text-dark me-2 flex-shrink-0">•</span>
                                <span className="mt-1">
                                    <span className="text-dark">
                                    {commonLabels.HOME_INSTRUCTIONS.HOME_NOTE_5_3}
                                    </span>
                                    <br/>
                                    <span>
                                        {commonHILabels.HOME_INSTRUCTIONS.HOME_NOTE_5_3}
                                    </span>
                                </span>
                            </p>
                            <p className="text-start ml38 d-flex align-items-start mb-2">
                                <span className="f20 text-dark me-2 flex-shrink-0">•</span>
                                <span className="mt-1">
                                    <span className="text-dark">
                                    {commonLabels.HOME_INSTRUCTIONS.HOME_NOTE_5_4}
                                    </span>
                                    <br/>
                                    <span>
                                        {commonHILabels.HOME_INSTRUCTIONS.HOME_NOTE_5_4}
                                    </span>
                                </span>
                            </p>
                            <p className="text-start ml38 d-flex align-items-start mb-2">
                                <span className="f20 text-dark me-2 flex-shrink-0">•</span>
                                <span className="mt-1">
                                    <span className="text-dark">
                                    {commonLabels.HOME_INSTRUCTIONS.HOME_NOTE_5_5}
                                    </span>
                                    <br/>
                                    <span>
                                        {commonHILabels.HOME_INSTRUCTIONS.HOME_NOTE_5_5}
                                    </span>
                                </span>
                            </p>
                            <p className="text-start ml38 d-flex align-items-start">
                                <span className="f20 text-dark me-2 flex-shrink-0">•</span>
                                <span className="mt-1">
                                    <span className="text-dark">
                                    {commonLabels.HOME_INSTRUCTIONS.HOME_NOTE_5_6}
                                    </span>
                                    <br/>
                                    <span>
                                        {commonHILabels.HOME_INSTRUCTIONS.HOME_NOTE_5_6}
                                    </span>
                                </span>
                            </p>

                            <p className="text-start ms-4 mb-2">
                                <span className="text-dark font-weight-bold">
                                    {commonLabels.HOME_INSTRUCTIONS.HOME_NOTE_6}
                                </span>
                                <br/>
                                <span>
                                    {commonHILabels.HOME_INSTRUCTIONS.HOME_NOTE_6}
                                </span>
                            </p>
                            <p className="text-start ml38 d-flex align-items-start mb-2">
                                <span className="f20 text-dark me-2 flex-shrink-0">•</span>
                                <span className="mt-1">
                                    <span className="text-dark">
                                    {commonLabels.HOME_INSTRUCTIONS.HOME_NOTE_6_1}
                                    </span>
                                    <br/>
                                    <span>
                                        {commonHILabels.HOME_INSTRUCTIONS.HOME_NOTE_6_1}
                                    </span>
                                </span>
                            </p>
                            <p className="text-start ml38 d-flex align-items-start mb-2">
                                <span className="f20 text-dark me-2 flex-shrink-0">•</span>
                                <span className="mt-1">
                                    <span className="text-dark">
                                    {commonLabels.HOME_INSTRUCTIONS.HOME_NOTE_6_2}
                                    </span>
                                    <br/>
                                    <span>
                                        {commonHILabels.HOME_INSTRUCTIONS.HOME_NOTE_6_2}
                                    </span>
                                </span>
                            </p>
                            <p className="text-start ml38 d-flex align-items-start mb-2">
                                <span className="f20 text-dark me-2 flex-shrink-0">•</span>
                                <span className="mt-1">
                                    <span className="text-dark">
                                    {commonLabels.HOME_INSTRUCTIONS.HOME_NOTE_6_3}
                                    </span>
                                    <br/>
                                    <span>
                                        {commonHILabels.HOME_INSTRUCTIONS.HOME_NOTE_6_3}
                                    </span>
                                </span>
                            </p>
                            <p className="text-start ml38 d-flex align-items-start mb-2">
                                <span className="f20 text-dark me-2 flex-shrink-0">•</span>
                                <span className="mt-1">
                                    <span className="text-dark">
                                    {commonLabels.HOME_INSTRUCTIONS.HOME_NOTE_6_4}
                                    </span>
                                    <br/>
                                    <span>
                                        {commonHILabels.HOME_INSTRUCTIONS.HOME_NOTE_6_4}
                                    </span>
                                </span>
                            </p>
                            <p className="text-start ml38 d-flex align-items-start mb-2">
                                <span className="f20 text-dark me-2 flex-shrink-0">•</span>
                                <span className="mt-1">
                                    <span className="text-dark">
                                    {commonLabels.HOME_INSTRUCTIONS.HOME_NOTE_6_5}
                                    </span>
                                    <br/>
                                    <span>
                                        {commonHILabels.HOME_INSTRUCTIONS.HOME_NOTE_6_5}
                                    </span>
                                </span>
                            </p>
                            <p className="text-start ml38 d-flex align-items-start">
                                <span className="f20 text-dark me-2 flex-shrink-0">•</span>
                                <span className="mt-1">
                                    <span className="text-dark">
                                    {commonLabels.HOME_INSTRUCTIONS.HOME_NOTE_6_6}
                                    </span>
                                    <br/>
                                    <span>
                                        {commonHILabels.HOME_INSTRUCTIONS.HOME_NOTE_6_6}
                                    </span>
                                </span>
                            </p>

                            <p className="text-start ms-4 mb-2">
                                <span className="text-dark font-weight-bold">
                                    {commonLabels.HOME_INSTRUCTIONS.HOME_NOTE_7}
                                </span>
                                <br/>
                                <span>
                                    {commonHILabels.HOME_INSTRUCTIONS.HOME_NOTE_7}
                                </span>
                            </p>
                            <p className="text-start ml38 d-flex align-items-start mb-1">
                                <span className="f20 text-dark me-2 flex-shrink-0">•</span>
                                <span className="mt-1">
                                    <span className="text-dark">
                                    {commonLabels.HOME_INSTRUCTIONS.HOME_NOTE_7_1}
                                    </span>
                                    <br/>
                                    <span>
                                        {commonHILabels.HOME_INSTRUCTIONS.HOME_NOTE_7_1}
                                    </span>
                                </span>
                            </p>
                            <p className="text-start ml38 d-flex align-items-start mb-1">
                                <span className="f20 text-dark me-2 flex-shrink-0">•</span>
                                <span className="mt-1">
                                    <span className="text-dark">
                                    {commonLabels.HOME_INSTRUCTIONS.HOME_NOTE_7_2}
                                    </span>
                                    <br/>
                                    <span>
                                        {commonHILabels.HOME_INSTRUCTIONS.HOME_NOTE_7_2}
                                    </span>
                                </span>
                            </p>
                            <p className="text-start ml38 d-flex align-items-start mb-1">
                                <span className="f20 text-dark me-2 flex-shrink-0">•</span>
                                <span className="mt-1">
                                    <span className="text-dark">
                                    {commonLabels.HOME_INSTRUCTIONS.HOME_NOTE_7_3}
                                    </span>
                                    <br/>
                                    <span>
                                        {commonHILabels.HOME_INSTRUCTIONS.HOME_NOTE_7_3}
                                    </span>
                                </span>
                            </p>
                            <p className="text-start ml38 d-flex align-items-start">
                                <span className="f20 text-dark me-2 flex-shrink-0">•</span>
                                <span className="mt-1">
                                    <span className="text-dark">
                                    {commonLabels.HOME_INSTRUCTIONS.HOME_NOTE_7_4}
                                    </span>
                                    <br/>
                                    <span>
                                        {commonHILabels.HOME_INSTRUCTIONS.HOME_NOTE_7_4}
                                    </span>
                                </span>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        )
};